import { BoxV2 } from 'sonata-react-components';
import styled from 'styled-components';

export const MediaChannelSelectionStepStyled: any = styled(BoxV2)`
  padding: 37px 24px 32px 24px;
  background-color: ${props => props.theme.uiColors.background01};
  border: 1px solid ${props => props.theme.uiColors.background01};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
`;
